module.exports = __webpack_public_path__ + "img/det-home.92d6c1c0.jpg";